import gql from 'graphql-tag';

const key = `UpdatePeriodPlanResult`;
const mutation = gql`
mutation ${key}($input:UpdatePeriodPlanResultInput!) {
  updatePeriodPlanResult(input:$input){
    id
    name
    checklist
    alerts
    targetHourLyCustomers
    actualHourLyCustomers
    targetWeeklyGp
    actualWeeklyGp
    targetWeeklyUpt
    actualWeeklyUpt
    targetWagePercent
    actualWagePercent
  }
}
`;

export const UPDATE_PERIOD_PLAN_RESULT = { key, mutation };
